import { handleRequest } from '../../utils/axios';
import { requestUploadImage } from '../uploadfile.service';

export const findNotificationsAPI = async (data) => {
  const config = {
    url: '/notification/search',
    method: 'POST',
    data
  };
  return handleRequest(config);
};

export const getNotificationByIdAPI = async (id) => {
  const config = {
    url: `/notification/${id}`,
    method: 'GET'
  };
  return handleRequest(config);
};

export const createNotificationAPI = async (data) => {
  const { fileObj, ...other } = data;
  let featureImage = null;

  const now = new Date();
  const path = `blog/${now.getFullYear()}/${now.getMonth()}/`;

  const resp = await requestUploadImage(fileObj, path);
  if (resp.code === '200')
    featureImage = resp.data;
  else return resp;

  const config = {
    url: '/notification/',
    method: 'POST',
    data: {
      ...other,
      featureImage
    }
  };

  return handleRequest(config);
};

export const updateNotificationAPI = async (data) => {
  const { fileObj, ...other } = data;

  let featureImage = other?.featureImage || null;

  if (fileObj.name) {
    const now = new Date();
    const path = `blog/${now.getFullYear()}/${now.getMonth()}/`;

    const resp = await requestUploadImage(fileObj, path);
    if (resp.code === '200')
      featureImage = resp.data;
    else return resp;
  }

  const config = {
    url: '/notification/',
    method: 'PUT',
    data: {
      ...other,
      featureImage
    }
  };

  return handleRequest(config);
};

export const deleteNotificationAPI = async (id) => {
  const config = {
    url: `/notification/${id}`,
    method: 'DELETE'
  };
  return handleRequest(config);
};

export const deleteNotificationsAPI = async (ids) => {
  const config = {
    url: `/notification/all/${ids.toString()}`,
    method: 'DELETE'
  };
  return handleRequest(config);
};
